import styled, { css } from "styled-components"
import {
  background,
  BackgroundProps,
  border,
  BorderProps,
  color,
  ColorProps,
  flexbox,
  FlexboxProps,
  grid,
  GridProps,
  layout,
  LayoutProps,
  position,
  PositionProps,
  shadow,
  ShadowProps,
  space,
  SpaceProps,
  typography,
  TypographyProps
} from "styled-system"

import {
  cursor,
  CursorProps,
  gridColumnEnd,
  GridColumnEndProps,
  gridColumnStart,
  GridColumnStartProps,
  objectFit,
  ObjectFitProps,
  textDecoration,
  TextDecorationProps,
  textTransform,
  TextTransformProps,
  transform,
  TransformProps,
  transition,
  TransitionProps,
} from "../customStyleProps"

import rawHtmlCss from "./rawHtmlCss"

export type ElementProps = React.HTMLAttributes<HTMLElement> &
  BackgroundProps &
  BorderProps &
  ColorProps &
  CursorProps &
  FlexboxProps &
  GridProps &
  GridColumnEndProps &
  GridColumnStartProps &
  LayoutProps &
  ObjectFitProps &
  PositionProps &
  ShadowProps &
  SpaceProps &
  TextDecorationProps &
  TextTransformProps &
  TransitionProps &
  TransformProps &
  TypographyProps

export const elementCss = css`
  box-sizing: border-box;

  ${background};
  ${border};
  ${color};
  ${cursor};
  ${flexbox};
  ${grid};
  ${gridColumnEnd};
  ${gridColumnStart};
  ${layout};
  ${objectFit};
  ${position};
  ${shadow};
  ${space};
  ${textDecoration};
  ${textTransform};
  ${transform}
  ${transition};
  ${typography};
`
const Element = styled.div<ElementProps>`
  ${elementCss};
  ${props => (props.dangerouslySetInnerHTML ? rawHtmlCss : null)};
`

export default Element
